/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-26 17:34:43
 * @LastEditTime: 2022-01-26 22:15:34
 * @LastEditors: zhao - 🍉
 * @Description: 租金宝同步数据 - 商户详情
 * @FilePath: /zhzj-admin/src/page/ZJBSyncDataRecord/components/MerchantDetailListModal.jsx
 */
import { Button, Modal } from 'antd'
import React, { useState, forwardRef, useImperativeHandle } from 'react'
import ModalScrollContainer from "../../../components/ModalScrollContainer";
import TableHelper from '../../../components/TableHelper'
import { fetchZJBSyncDataMerchantInfo } from '../../../services/ZJBSyncDataRecord'
import { commonIsMap, customerType, dicRoleStatus, mapZJBSyncDataDetailType } from "../../../axios/dictionaries";
import { findDict, formatTime } from '../../../utils';


const MerchantDetailListModal = (props, ref) => {
    const [visible, setVisible] = useState(false);
    const [defaultSearch, setDefaultSearch] = useState(null);
    useImperativeHandle(ref, () => ({
        open
    }))
    const open = (operationType, syncDate) => {
        setVisible(true)
        setDefaultSearch({ operationType, syncStartDate: syncDate, syncEndDate: syncDate })
    }
    const close = () => {
        setVisible(false)
        setDefaultSearch(null)
    }
    const columns = [
        { title: '商户编号', dataIndex: 'merchantNo', width: 140 },
        { title: '全称', dataIndex: 'name', width: 200, },
        { title: '简称', dataIndex: 'shortName',width: 140 },
        { title: '商户类型', dataIndex: 'merchantType', render: (text) => {
            return findDict(customerType,text).title
        }},
        { title: '法人身份证', dataIndex: 'legalPersonCredentialNumber',width: 190 },
        { title: '法人姓名', dataIndex: 'legalPersonName', },
        { title: '法人手机号', dataIndex: 'legalPersonPhone', },
        { title: '智管家端自动审核合同', dataIndex: 'autoReviewContract', width: 200, render: (text) => text ? '开' : '关'},
        { title: '账户账号', dataIndex: 'balanceAcc', },
        { title: '开户行网点号', dataIndex: 'balanceAccBankNo', },
        { title: '账户户名', dataIndex: 'balanceAccName', },
        { title: '上上签的数字证书', dataIndex: 'bestsignApplyCert', width: 200, render: (text) => text ? '已申请' : '未申请'},
        { title: '签名印章图片', dataIndex: 'bestsignSinatureCreated', render: (text) => text ? '已生成' : '未生成'},
        { title: '营业执照号码', dataIndex: 'businessLicenseNo', },
        { title: '是否清算', dataIndex: 'clarify', render: (text) => {
            return findDict(commonIsMap, text).title
        }},
        { title: '合同联系手机', dataIndex: 'contactPhone', },
        { title: '合同数据同步', dataIndex: 'contractDataSync', render: (text) => {
            return findDict(commonIsMap, text).title
        }},
       
        { title: '是否数据同步', dataIndex: 'dataSync', render: (text) => {
            return findDict(commonIsMap, text).title
        }},

        { title: '企业实名4要素', dataIndex: 'identify4', width: 120, render: (text) => text ? '已通过' : '未通过'},
        { title: '对接建行建融家园', dataIndex: 'isJr', width: 120, render: (text) => text === 1 ? '是' : '否'},

       
        { title: '消息提醒 ', dataIndex: 'messageReminding', render: (text) => text === 1 ? '开启' : '关闭'},
        { title: '子商户号', dataIndex: 'mid', },
     
        { title: '手机', dataIndex: 'phone', },
        { title: '房源数据同步', dataIndex: 'roomDataSync', render: (text) => {
            return findDict(commonIsMap, text).title
        }},
        { title: '分账比例', dataIndex: 'scale', },
        
        { title: '状态', dataIndex: 'status', render: (text) => {
            return findDict(dicRoleStatus, text).title
        }},
        { title: '是否分账', dataIndex: 'subAccount', render: (text) => text  ? '是' : '否'},
   
        // { title: 'undefined', dataIndex: 'userName', },
        { title: '租金宝数据同步开关', width: 130, dataIndex: 'zjbDataSync', render: (text) => {
            return findDict(commonIsMap, text).title
        }},
        { title: '创建时间', dataIndex: 'createTime',width: 150, render: formatTime},
        { title: '更新时间', dataIndex: 'updateTime',width: 150, render: formatTime},
    ]

    const searchOptions = [
        { key: 'operationType', type: 'select', options: mapZJBSyncDataDetailType },
        { key: 'syncStartDate', type: 'date', placeholder: '同步开始日期' },
        { key: 'syncEndDate', type: 'date', placeholder: '同步结束日期' },
    ]
    return (
        <Modal visible={visible} title="商户详情" width={950} destroyOnClose onCancel={close} footer={<Button onClick={close}>关闭</Button>}>
            {
                (visible && defaultSearch) && (
                    <ModalScrollContainer>
                        <TableHelper initialValue={defaultSearch} columns={columns} searchOptions={searchOptions} scroll={{ x: 3000 }} request={fetchZJBSyncDataMerchantInfo} />
                    </ModalScrollContainer>
                )
            }
        </Modal>
    )
}

export default forwardRef(MerchantDetailListModal)


// WEBPACK FOOTER //
// ./src/page/ZJBSyncDataRecord/components/MerchantDetailListModal.jsx